export const getValidDate = (date: string) => new Date(!isNaN(Number(date)) ? parseInt(date) : date);

export const getTeaserTimeFormat = (date, timeZoneFormat, twelveHourFormat) => {
  return twelveHourFormat
    ? date.toLocaleTimeString(timeZoneFormat, { hour12: true, hour: "2-digit", minute: "numeric" })
    : date.toLocaleTimeString(timeZoneFormat, { hour12: false, hour: "2-digit", minute: "numeric" });
};

export const getTeaserDate = (date) => date.getDate();

export const getTeaserMonth = (date, timeZoneFormat) => date.toLocaleString(timeZoneFormat, { month: "short" });

export const getTeaserYear = (date) => date.getFullYear();
